export enum PerpetualType {
  Favorite = 'Favorite',
  Inverse = 'Inverse',
  USD = 'USD',
  USDS = 'USDS',
  mUSDT = 'mUSDT',
}

export const enum FavoritesStatus {
  Visible = 'Visible',
  Hidden = 'Hidden',
}

// k线价格类型
export enum PriceType {
  Last = 'Last',
  Index = 'Index',
  Mark = 'Mark',
}

// 分段订单类型
export enum ScaledOrderType {
  Flat = 'Flat',
  Increment = 'Increment',
  Decrement = 'Decrement',
}

export enum TpSlPriceType {
  Roi = 'ROI',
  Pnl = 'Pnl',
  PriceChange = 'PriceChange',
}
